import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, CircularProgress } from '@mui/material';
import { t } from 'i18next';
import { fetchPlanByUUID } from '../../../services/plans';
import CreatePlan from './CreatePlan';

const DuplicatePlan = () => {
    const { uuid } = useParams();
    const navigate = useNavigate();
    const [originalPlan, setOriginalPlan] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadPlan = async () => {
            try {
                const plan = await fetchPlanByUUID(uuid);
                setOriginalPlan(plan);
            } catch (err) {
                console.error('Erro ao carregar plano:', err);
                navigate('/planos');
            } finally {
                setLoading(false);
            }
        };
        loadPlan();
    }, [uuid, navigate]);

    if (loading) return <CircularProgress />;
    if (!originalPlan) return <Typography>{t('planViewer.plan_not_found')}</Typography>;

    const duplicatedData = {
        ...originalPlan.data,
        sessions: originalPlan.data.sessions.map((s) => ({
            ...s,
            id: Date.now() + Math.random(),
            exercises: s.exercises.map((ex) => ({
                ...ex,
                id: Date.now() + Math.random()
            }))
        }))
    };

    return (
        <CreatePlan
            initialName={t('planViewer.copy_of', { name: originalPlan.name })}
            initialDescription={originalPlan.description}
            initialData={duplicatedData}
        />
    );
};

export default DuplicatePlan;
